import styled from "styled-components";

export const StyledUserInfo = styled.div`
  padding: var(--spacing-md);
  border: 1px solid var(--color-text-10);
  background-color: var(--color-text-5);
  border-radius: var(--radius-lg);
  margin-bottom: var(--spacing-xl);
  button {
    width: 100%;
  }
`;

export const StyledUserInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding-bottom: var(--spacing-md);
  h4 {
    font-size: var(--font-size-lg);
    font-weight: 600;
    color: var(--color-text);
  }
`;
